<ng-template #templateRef>
	<app-list-item-menu-container>
		<app-vehicle-status-button [isEditMode]="isEditMode()" [id]="item().id" />
		<app-vehicle-delete-button
			(onDeleteCalled)="onDeleteResponse($event)"
			[id]="item().id"
			[licensePlate]="item().licensePlate" />
	</app-list-item-menu-container>
</ng-template>
